import gql from 'graphql-tag';

export const GET_NOTIFICATION_CHANNELS = gql`
  query ($tenantId: ID!) {
    channelConfigs(tenantId: $tenantId) {
      id
      channel
      collectors {
        id
        name
      }
    }
  }
`;

export const GET_COLLECTORS = gql`
  query ($tenantId: ID!) {
    searchCollectors(tenantId: $tenantId) {
      id
      name
      channelConfigIds
    }
  }
`;
